import React, { Fragment, useState, useEffect } from "react";
import { useAsyncEffect } from "@kido/hooks";
import { useTranslation } from "react-i18next";
import { Select as SV, Button, Week } from "@kido/ui";
import { useRecoilState } from "recoil";
import {
  appThemeSelector,
  filtersSelector,
  tokenSelector,
  reportIDSelector,
} from "../../store/selectors";
import { getHostLevels, onCreateReport } from "../../data/request";
import Stripe from "../Stripe";
import getAmounts from "../../data/amounts";
import { months, defaultHosts, defaultOptions } from "./Filters.config";

const Filters = ({ generate }) => {
  const [theme] = useRecoilState(appThemeSelector);
  const [filters, setFilters] = useRecoilState(filtersSelector);
  const [token, setToken] = useRecoilState(tokenSelector);
  const [reportID, setReportID] = useRecoilState(reportIDSelector);
  const [active, setActive] = useState({ host_level: null, host_id: null });
  const [month, setMonth] = useState(null);
  const [hosts, setHosts] = useState(defaultHosts);
  const [options, setOptions]: any = useState(defaultOptions);
  const [payment, setPayment] = useState(false);
  const [hostType, setHostType] = useState(null);
  const { t } = useTranslation();

  const onSetFilters = () =>
    setFilters({
      ...filters,
      hosts: hosts,
      host_level: active.host_level,
      host_id: active.host_id,
      PRO: hosts.PRO && hosts.PRO.label,
      COM: hosts.COM && hosts.COM.label,
      SEC: hosts.SEC && hosts.SEC.label,
      MUN: hosts.MUN && hosts.MUN.label,
      DIS: hosts.DIS && hosts.DIS.label,
      districts: options.DIS,
      token,
    });

  useAsyncEffect(async () => {
    const provinces = await getHostLevels("PRO");
    setOptions({ ...options, PRO: provinces.data });
  }, []);

  const onRequestPDF = () => {
    generate.current = true;

    onSetFilters();
  };

  const onDateChange = (value) => {
    setFilters({ ...filters, dates: [value.id[0], value.id[1]] });
  };

  const onMonthChange = (value) => {
    const m = months[value.id];

    setMonth(value.label);
    setFilters({ ...filters, dates: [m[0], m[1]] });
  };

  const onHostLevelChange = (currentLevel, nextLevel) => async (value) => {
    const newOptions = await getHostLevels(nextLevel, value.id);

    setOptions({ ...options, [nextLevel]: newOptions.data });
    setHosts({
      ...hosts,
      [currentLevel]: value,
      population: value.population,
      amount: getAmounts(value.population),
    });
    setActive({ host_level: currentLevel, host_id: value.id });
    setFilters({
      ...filters,
      position: value.position,
      host_level: currentLevel,
      population: value.population,
    });
  };

  const onProvinceChange = onHostLevelChange("PRO", "COM");

  const onDISCChange = onHostLevelChange("DIS", "SEC");

  const onMUNChange = onHostLevelChange("MUN", "DIS");

  const onCOMChange = onHostLevelChange("COM", "MUN");

  const onGeneratePDF = async () => {
    onSetFilters();

    const report = await onCreateReport({
      host_id: active.host_id,
      host_level: active.host_level,
      dates: filters.dates,
      period: filters.period,
    });

    setReportID(report.data.report_id);
    setToken(report.data.token);
    setPayment(true);
  };

  const onHostTypeChange = ({ id }) => {
    setHostType(id);
    setActive({ host_level: null, host_id: null });
    setHosts(defaultHosts);
  };

  const onReset = () => {
    /*     setHostType(null);
    setMonth(null);
    setActive({ host_level: null, host_id: null });
    setHosts(defaultHosts);
    setPayment(false);
    setFilters({
      host_level: null,
      host_id: null,
      period: "monthly",
      dates: [],
      position: []
    }); */
    window.location.reload(false);
  };

  return (
    <div className="">
      {
        <h1
          style={{
            color: " #144052",
            fontSize: "22px",
            fontWeight: "bold",
            marginBottom: "35px",
          }}
        >
          {payment ? "Su informe" : "Configure su informe"}
        </h1>
      }
      {!payment && (
        <Fragment>
          {/*  <SV
            mode={theme.mode}
            options={['weekly', 'monthly'].map((d) => ({
              label: t(d),
              id: d
            }))}
            onChange={onTimeframeChange}
            placeholder="Time frame"
            value={{ label: filters.period.charAt(0).toUpperCase() + filters.period.slice(1), id: filters.period }}
          /> */}
          <div className="mb-4"></div>
          {filters.period === "monthly" && (
            <SV
              mode={theme.mode}
              /*options={['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'].map(*/
              options={[
                "jan-19",
                "feb-19",
                "mar-19",
                "apr-19",
                "may-19",
                "jun-19",
                "jul-19",
                "aug-19",
                "sep-19",
                "oct-19",
                "nov-19",
                "dec-19",
                "jan-20",
                "feb-20",
                "mar-20",
                "apr-20",
                "may-20",
                "jun-20",
                "jul-20",
                "aug-20",
                "sep-20",
                "oct-20",
                "nov-20",
                "dec-20",
                "jan-21",
                "feb-21",
                "mar-21",
                "apr-21",
              ].map((d) => ({
                label: t(d),
                id: d,
              }))}
              onChange={onMonthChange}
              placeholder="Seleccione un mes"
            />
          )}
          <div className="mb-4"></div>
          <SV
            mode={theme.mode}
            options={[
              {
                label: "Provincia",
                id: "PRO",
              },
              {
                label: "Comarca",
                id: "COM",
              },
              {
                label: "Municipio",
                id: "MUN",
              },
              {
                label: "Distrito",
                id: "DIS",
              },
            ]}
            style={{
              width: 320,
            }}
            onChange={onHostTypeChange}
            placeholder="Seleccione Zona/Area de visita"
          />
          <div className="mb-4"></div>
          {filters.period === "weekly" && (
            <Week theme={theme} onChange={onDateChange} />
          )}
          <div className="mb-4"></div>
          {(hostType === "PRO" ||
            hostType === "COM" ||
            hostType === "MUN" ||
            hostType === "DIS") && (
            <SV
              mode={theme.mode}
              options={options.PRO.map((d) => ({
                label: d.host_name,
                id: d.host_id,
                population: d.population,
                position: [d.lat, d.lng],
              }))}
              style={{
                width: 320,
              }}
              onChange={onProvinceChange}
              placeholder="Seleccione una provincia"
            />
          )}
          <div className="mb-4"></div>
          {hosts.PRO &&
            (hostType === "COM" ||
              hostType === "MUN" ||
              hostType === "DIS") && (
              <SV
                mode={theme.mode}
                options={options.COM.map((d) => ({
                  label: d.host_name,
                  id: d.host_id,
                  population: d.population,
                  position: [d.lat, d.lng],
                }))}
                style={{
                  width: 320,
                }}
                onChange={onCOMChange}
                placeholder="Comarca"
              />
            )}
          <div className="mb-4"></div>
          {hosts.COM && (hostType === "MUN" || hostType === "DIS") && (
            <Fragment>
              <SV
                mode={theme.mode}
                options={options.MUN.map((d) => ({
                  label: d.host_name,
                  id: d.host_id,
                  population: d.population,
                  position: [d.lat, d.lng],
                }))}
                style={{
                  width: 320,
                }}
                onChange={onMUNChange}
                placeholder="Municipio"
              />
              <div className="mb-4"></div>
            </Fragment>
          )}
          {hosts.MUN && hostType === "DIS" && (
            <Fragment>
              <SV
                mode={theme.mode}
                options={options.DIS.map((d) => ({
                  label: d.host_name,
                  id: d.host_id,
                  population: d.population,
                  position: [d.lat, d.lng],
                }))}
                style={{
                  width: 320,
                }}
                onChange={onDISCChange}
                placeholder="Distrito"
              />
              <div className="mb-4"></div>
            </Fragment>
          )}
          {/*           {hosts.DIS && (
            <Fragment>
              <SV
                mode={theme.mode}
                options={options.SEC.map((d) => ({
                  label: d.host_name,
                  id: d.host_id
                }))}
                style={{
                  width: 320
                }}
                onChange={onSECCHange}
                placeholder="Sector"
              />
              <div className="mb-4"></div>
            </Fragment>
          )} */}
        </Fragment>
      )}
      {payment && (
        <div className="review">
          <div className="flex mb-4">
            <label>{t("period")}: </label> <strong>Mensual</strong>
          </div>
          <div className="flex mb-4">
            <label>{t("month")}: </label> <strong>{month}</strong>
          </div>
          {hosts.PRO && (
            <div className="flex mb-4">
              <label>{t("province")}: </label>{" "}
              <strong>{hosts.PRO.label}</strong>
            </div>
          )}
          {hosts.COM && (
            <div className="flex mb-4">
              <label>Comarca: </label> <strong>{hosts.COM.label}</strong>
            </div>
          )}
          {hosts.MUN && (
            <div className="flex mb-4">
              <label>{t("municipality")}: </label>{" "}
              <strong>{hosts.MUN.label}</strong>
            </div>
          )}
          {hosts.DIS && (
            <div className="flex mb-4">
              <label>{t("district")}: </label>{" "}
              <strong>{hosts.DIS.label}</strong>
            </div>
          )}
          <div className="mb-4"></div>
          <button
            style={{
              background: "none",
              border: "none",
              textDecoration: "underline",
              color: "rgb(20, 64, 82)",
            }}
            onClick={onReset}
          >
            Limpiar selección
          </button>
        </div>
      )}
      <div className="mb-16"></div>
      {payment ? (
        <Stripe onPayment={onRequestPDF} amount={hosts.amount} />
      ) : (
        hosts[hostType] &&
        filters.dates.length !== 0 && (
          <div className="mb-20">
            <Button mode={theme.mode} onClick={onGeneratePDF}>
              Solicitar informe
            </Button>
          </div>
        )
      )}
    </div>
  );
};

export default Filters;
